<!-- Componente completo -->
<template>
  <section class="relative bg-[#F8F8F8] pt-2 md:pt-32">
    <div class="relative z-20 max-w-7xl mx-auto px-6">
      <!-- Contenedor principal (card flotante) -->
      <div
        class="bg-white rounded-3xl shadow-[8px_10px_24px_-8px_rgba(0,0,0,0.3)] -mt-20 md:-mt-[13.5rem] md:pb-28 px-6 md:px-12 py-6 md:py-12 mx-auto max-w-xl md:max-w-5xl"
      >
        <!-- Header -->
        <div class="text-center space-y-3 mb-10 md:pt-14">
          <h2 class="text-3xl md:text-4xl font-extrabold text-[#101541] pb-2">
            {{ $t('empresas.title') }}
          </h2>
          <p class="font-normal text-xl md:text-2xl pt-2">
            {{ $t('empresas.subtitle') }}
          </p>
        </div>

        <!-- Cards -->
        <div class="flex justify-center">
          <div class="grid grid-cols-1 md:grid-cols-2 md:max-w-3xl max-w-sm w-full gap-6 md:gap-16">
            <!-- Servicios personales -->
            <RouterLink to="/personal" class="group relative aspect-square rounded-2xl overflow-hidden">
              <img
                src="../assets/Tranquilidad.png"
                alt="Servicios personales"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div class="absolute inset-0 bg-black/35"></div>
              <div class="absolute inset-0 flex items-center justify-center">
                <span class="text-white text-center text-2xl md:text-2xl font-semibold tracking-wide">
                  {{ $t('empresas.personalServices') }}
                </span>
              </div>
            </RouterLink>
            <!-- Servicios empresariales -->
            <RouterLink to="/empresas" class="group relative aspect-square rounded-2xl overflow-hidden">
              <img
                src="../assets/RC.png"
                alt="Servicios empresariales"
                class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              <div class="absolute inset-0 bg-black/35"></div>
              <div class="absolute inset-0 flex items-center justify-center">
                <span class="text-white text-center text-2xl md:text-2xl font-semibold tracking-wide">
                  {{ $t('empresas.businessServices') }}
                </span>
              </div>
            </RouterLink>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'

useI18n()

const selectedCategory = ref('Daños')
const selectedOption = ref('responsabilidad')

const optionsByCategory = {
  Daños: [
    { value: 'responsabilidad', label: 'Responsabilidad civil' },
    { value: 'paquete', label: 'Paquete empresarial' },
    { value: 'construccion', label: 'Construcción' },
    { value: 'terrorismo', label: 'Terrorismo' },
    { value: 'ciberseguridad', label: 'Ciberseguridad' },
    { value: 'fianzas', label: 'Fianzas' },
    { value: 'especiales', label: 'Especiales' },
    { value: 'transporte', label: 'Transporte' },
    { value: 'aviacion', label: 'Aviación' },
    { value: 'embarcaciones', label: 'Embarcaciones' }
  ],
  Beneficios: [
    { value: 'vida_colectivo', label: 'Seguro de vida colectivo' },
    { value: 'medico_colectivo', label: 'Gastos médicos colectivo' },
    { value: 'accidentes_colectivo', label: 'Accidentes colectivo' }
  ],
  Autos: [{ value: 'flotillas', label: 'Flotillas' }]
}

watch(selectedCategory, (newCategory) => {
  selectedOption.value = optionsByCategory[newCategory][0].value
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
